// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__j-ECg","QuizWrapper":"Quiz_QuizWrapper__2UBOb"};